import styled, { css } from 'styled-components';
export const SelectBase = styled.div.attrs({
    className: 'select',
}) `
  display: inline-flex;
  flex-direction: column;
  position: relative;

  color: var(--color-on--background);
  font-family: 'Open Sans';
  font-size: 16px;
  line-height: 24px;

  &[aria-disabled='true'] {
    color: var(--color-disabled);
  }

  ${({ fluid }) => fluid &&
    css `
      width: 100%;
      max-width: 100%;

      & > ${Container} {
        width: 100%;

        & > select {
          width: 100%;
        }
      }
    `}

  & > .hint {
    margin: -8px 0 16px 0;
  }
`;
export const Label = styled.label `
  display: flex;
  align-items: center;

  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;

  margin-bottom: 16px;
`;
// Helper function to have the padding size in one place
// as it needs to change base on the border size.
const padding = (options) => {
    var _a, _b;
    return css `
  padding-top: 0;
  padding-right: calc(40px - ${(_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : 0}px);
  padding-bottom: 0;
  padding-left: calc(8px - ${(_b = options === null || options === void 0 ? void 0 : options.offset) !== null && _b !== void 0 ? _b : 0}px);
`;
};
export const NativeSelect = styled.select `
  /* reset start */
  appearance: none;
  background: var(--color-on-primary);
  border: 1px solid var(--color-on-background);
  padding: 0 1em 0 0;
  margin: 0;

  font-family: inherit;
  font-size: inherit;
  cursor: inherit;
  line-height: inherit;
  color: var(--color-on-background);
  /* reset end */

  position: relative;
  height: 40px;
  ${padding()}
  border-radius: 2px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:focus {
    outline: none;
    border: 2px solid var(--color-selection);
    ${padding({ offset: 1 })}
  }

  &:focus-visible {
    border: 2px solid var(--color-selection);
  }

  &:disabled {
    border-color: var(--color-disabled);
    color: var(--color-disabled);
    background: var(--color-on-primary);
    cursor: not-allowed;
  }

  & > option {
    font-family: 'Open Sans';
  }

  ${({ small, large }) => {
    if (small)
        return css `
        width: 96px;
      `;
    if (large)
        return css `
        width: 288px;
      `;
    return css `
      width: 148px;
    `;
}};

  ${({ error }) => error &&
    css `
      border: 3px solid var(--color-error-accent);
      /* Offset the padding with 2px since the error border is
        2px larger than in the normal state. This is to prevent the
        text from shifting by 2px when it is in error state. */
      ${padding({ offset: 2 })}
    `}
`;
export const Container = styled.div `
  position: relative;
  display: flex;
  align-self: flex-start;

  & > i {
    position: absolute;
    bottom: 12px;
    right: 16px;
    pointer-events: none;
    font-size: 16px;
    line-height: 16px;
  }
`;
